'use strict';

import { IndFlowAssignmentCollection } from '@api/Collections/Ind/IndFlowAssignmentCollection';
import { CoreRepository } from '../CoreRepository';
import { IndFlowAssignment } from '@api/Entities/Ind/IndFlowAssignment';

export class IndFlowAssignmentRepository extends CoreRepository {
  public getIndFlowAssignments(indId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndFlowAssignments(indId, options).then((response) => {
      const collection = new IndFlowAssignmentCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndFlowAssignment();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getIndFlowAssignment(indId: number, assignmentId: number, options: object = null) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getIndFlowAssignment(indId, assignmentId, options).then((response) => {
      if (!response) {
        return false;
      }

      const individualFlowAssignment = new IndFlowAssignment();
      individualFlowAssignment.hydrate(response);

      return individualFlowAssignment;
    });
  }

  public getIndFlowHistory(indId: number, options: object = {}) {
    return this.webAPI.getIndFlowHistory(indId, options).then((response) => {
      return response;
    });
  }

  public createIndFlowAssignment(indId: number, payload: object = {}) {
    return this.webAPI.addIndFlowAssignment(indId, payload).then((response) => {
      const individualFlowAssignment = new IndFlowAssignment();
      individualFlowAssignment.hydrate(response);

      return individualFlowAssignment;
    });
  }

  public createIndFlowAssignmentBulk(payload: {
    individualIds: number[];
    flowId: number;
    stageId: number;
    movedBy?: string;
  }) {
    return this.webAPI.addIndFlowAssignmentBulk(payload).then((response) => {
      return response;
    });
  }

  public closeIndFlowAssignment(indId: number, assignmentId: number, payload: object = {}) {
    return this.webAPI.closeIndFlowAssignment(indId, assignmentId, payload).then((response) => {
      const individualFlowAssignment = new IndFlowAssignment();
      individualFlowAssignment.hydrate(response);

      return individualFlowAssignment;
    });
  }

  public moveIndFlowAssignment(indId: number, payload: object = {}) {
    return this.webAPI.moveIndFlowAssignment(indId, payload).then((response) => {
      const individualFlowAssignment = new IndFlowAssignment();
      individualFlowAssignment.hydrate(response);

      return individualFlowAssignment;
    });
  }

  public removeIndFlowAssignment(indId: number, assignmentId: number) {
    return this.webAPI.removeIndFlowAssignment(indId, assignmentId).then((response) => {
      return response;
    });
  }

  public moveAllInStage(flowId: number, payload: object = {}) {
    return this.webAPI.moveAllInStage(flowId, payload).then((response) => {
      const individualFlowAssignment = new IndFlowAssignment();
      individualFlowAssignment.hydrate(response);

      return individualFlowAssignment;
    });
  }

  public removeAllInStage(flowId: number, stageId: number) {
    return this.webAPI.removeAllInStage(flowId, stageId).then((response) => {
      return response;
    });
  }

  public closeAllInStage(flowId: number, payload: object = {}) {
    return this.webAPI.closeAllInStage(flowId, payload).then((response) => {
      const individualFlowAssignment = new IndFlowAssignment();
      individualFlowAssignment.hydrate(response);

      return individualFlowAssignment;
    });
  }
}
